import * as THREE from 'three'

interface Position {
  x: number
  y: number
  z: number
}

interface LightShadowSettings {
  position: Position
  near: number
  far: number
  extends: number
  resolution: number
  bias: number
  radius: number
}

interface LightSettings {
  shadow: LightShadowSettings
}

const defaultLightSettings: LightSettings = {
  shadow: {
    position: {
      x: -1,
      y: 1,
      z: 6,
    },
    near: 0,
    far: 7,
    extends: 8,
    resolution: 1024,
    bias: 0,
    radius: 1,
  },
}

/**
 * Creates a new Three.js directional light.
 */
export const createDirectionalLight = (
  lightSettings: LightSettings = defaultLightSettings,
) => {
  const directionalLight = new THREE.DirectionalLight('white', 1)

  directionalLight.position.set(
    lightSettings.shadow.position.x,
    lightSettings.shadow.position.y,
    lightSettings.shadow.position.z,
  )

  directionalLight.castShadow = true
  directionalLight.shadow.camera.near = lightSettings.shadow.near
  directionalLight.shadow.camera.far = lightSettings.shadow.far
  directionalLight.shadow.camera.right = lightSettings.shadow.extends
  directionalLight.shadow.camera.left = -lightSettings.shadow.extends
  directionalLight.shadow.camera.top = lightSettings.shadow.extends
  directionalLight.shadow.camera.bottom = -lightSettings.shadow.extends
  directionalLight.shadow.mapSize.width = lightSettings.shadow.resolution
  directionalLight.shadow.mapSize.height = lightSettings.shadow.resolution
  directionalLight.shadow.bias = lightSettings.shadow.bias
  directionalLight.shadow.radius = lightSettings.shadow.radius
  directionalLight.intensity = 0.7

  return directionalLight
}

/**
 * Creates a new Three.js ambient light.
 */
export const createAmbientLight = (ambientColor = 'white') => {
  const ambientLight = new THREE.AmbientLight(ambientColor)
  ambientLight.intensity = 0.5

  return ambientLight
}
